import { InsuredApprovedLenderName } from '../components/HbtPortfolioManagementRequestOverview/components/HbtIndividualLoanDetails/types';

export const getInsuredApprovedlenderName = (
  data: InsuredApprovedLenderName | undefined,
  language: string
) => {
  return language === 'en' ? data?.englishName : data?.frenchName;
};
